module.exports = __webpack_public_path__ + "static/img/third1_8_active.ba1dbc8b.png";